module.exports = __webpack_public_path__ + "img/CO.f54879b6.svg";